import { useCallback } from 'react';
import { useRouter } from 'next/router';
import URL from '@/creditflowresearch/Router/urlConstants';
import { IRedirectInfo } from '@/creditflowresearch/application/Research/types';

export const useRedirectHandling = () => {
  const { replace, asPath } = useRouter();

  const buildRedirectUrl = useCallback((redirectInfo: IRedirectInfo): string => {
    const searchParams = asPath.includes('?') ? asPath.substring(asPath.indexOf('?')) : '';
    return `${ URL.NRSRO_RESEARCH }/${ redirectInfo.redirectParams.documentGroup.groupName }${ searchParams }`;
  }, [asPath]);

  return useCallback((redirectInfo: IRedirectInfo): void => {
    if (!redirectInfo.shouldRedirect) return;

    const redirectUrl = buildRedirectUrl(redirectInfo);
    replace(redirectUrl, undefined, { shallow: true });
  }, [replace, buildRedirectUrl]);
};
